import React from 'react';
import PortfolioSpotlight from '../portfolio/PortfolioSpotlight';

const PortfolioPreview = () => (
  <PortfolioSpotlight sectionId="portfolio" showPageCta />
);

export default PortfolioPreview;
